import FlexColumn from "designSystem/components/flex/FlexColumn";
import PaneHeader from "designSystem/components/pane/PaneHeader";
import React from "react";
import { HeaderCallbacks, SelectedChannel } from "../../types";
import ConnectToSlackFirstTime from "./ConnectToSlackFirstTime";
import ConnectToSlackNextTime from "./ConnectToSlackNextTime";

interface Props extends HeaderCallbacks {
	nodeType: string;
	isNodeReadOnly: boolean;
	nodeSlackChannels: string[];
	onConnectToSlack?: () => void;
	onSelectChannel?: (channel: SelectedChannel) => void;
}

const ConnectToSlack: React.FunctionComponent<Props> = ({ nodeType, isNodeReadOnly, nodeSlackChannels, onBack, onClose, onConnectToSlack, onSelectChannel }) => {
	return (
		<FlexColumn>
			<PaneHeader
				back={false}
				onBack={onBack}
				onClose={onClose}
				titleRes="Slack"
			/>
			{0 === nodeSlackChannels.length
				? (
					<ConnectToSlackFirstTime
						isNodeReadOnly={isNodeReadOnly}
						nodeType={nodeType}
						onConnectToSlack={onConnectToSlack}
					/>
				)
				: (
					<ConnectToSlackNextTime
						isNodeReadOnly={isNodeReadOnly}
						nodeSlackChannels={nodeSlackChannels}
						nodeType={nodeType}
						onConnectToSlack={onConnectToSlack}
						onSelectChannel={onSelectChannel}
					/>
				)
			}
		</FlexColumn>
	);
};

export default ConnectToSlack;